export enum ErrorCode {
        KHONG_TIM_THAY_CON_TACT_CONFIG = 1,
}